export default "__VITE_ASSET__CQanrNU8__"